import { GEO_LOCATION_INLINE_DISPLAY_LIMIT } from '../../../env'

export function getInlineGeoLocationsDisplay<T>(value: T[]): {
  displayValue: T[]
  exceedsInlineLimit: boolean
  totalCount: number
} {
  const totalCount = value.length
  const exceedsInlineLimit = totalCount > GEO_LOCATION_INLINE_DISPLAY_LIMIT
  const displayValue = exceedsInlineLimit ? value.slice(0, GEO_LOCATION_INLINE_DISPLAY_LIMIT) : value

  return { displayValue, exceedsInlineLimit, totalCount }
}
